/**
 * ui处理类，
 * 模版工具
 * dom距离计算工具
 * **/
import createStyleSheet from "./createStyleSheet";
import sdkTool from "./sdkTool";
//建立全局对象，如果

var cssObj ={};
if(typeof  window.IfengAmgr !="undefined"){
    if(!window.IfengAmgr.hasOwnProperty("STYLE_MGR")){
        window.IfengAmgr.STYLE_MGR ={};
    }
    if(!window.IfengAmgr.hasOwnProperty("DIV_ID")){
        window.IfengAmgr.DIV_ID =0;
    }
    cssObj =window.IfengAmgr.STYLE_MGR;
}

var UiTool = {
    getTemplate:function (c,css,t,cName) {
        if (typeof css != "undefined") {
            if(!cssObj.hasOwnProperty(cName)){
                let uuid = sdkTool.creatUuid();
                css =css.replace(new RegExp(cName,"g"), cName+uuid);
                createStyleSheet(css);
                cssObj[cName] =cName+uuid;
            }
            t =t.replace(new RegExp(cName,"g"),cssObj[cName]);
        }
        var id = sdkTool.creatUuid();
        if(window.IfengAmgr&&window.IfengAmgr.hasOwnProperty("DIV_ID")){
            id +="_"+ window.IfengAmgr.DIV_ID;
            window.IfengAmgr.DIV_ID++;
        }
        var yArr = t.match(/#{[a-z_A-Z0-9]{1,}}/g) || [];
        var keyArr = [];
        for (var i = 0; i < yArr.length; i++) {
            var k = yArr[i].replace(/^#{?|}$/g, "");
            t = t.replace(yArr[i], k + id);
            keyArr.push(k);
        }
        c.innerHTML = t;
        c.doms ={};
        for (var i = 0; i < keyArr.length; i++) {
            var k = keyArr[i];
            c.doms[k] = UiTool.$E(k + id);
        }
        return keyArr;
    },
    $E:function (b) {
        var a = typeof b == "string" ? document.getElementById(b) : b;
        if (a != null) {
            return a
        } else {
        }
        return null
    },
    $C:function (tag) {
        return document.createElement(tag);
    },
    imgResize:function(picWrap,src,cutType){
        var ct = UiTool.$E(picWrap);
        console.log(ct);
        if(ct){
            var imgDom = ct.getElementsByTagName('img')[0];
            imgDom.onload = function(){
                var w =this.width,h=this.height;
                var layoutWidth = ct.clientWidth, layoutHeight = ct.clientHeight,wRatio = layoutWidth / w,
                    hRatio = layoutHeight / h,ratio;

                if (wRatio<1 || hRatio<1){
                    ratio = (cutType!=1)?(wRatio>=hRatio?wRatio:hRatio):(wRatio<=hRatio?wRatio:hRatio);
                }else{
                    ratio = wRatio>=hRatio?wRatio:hRatio;
                }
                switch(cutType){
                    case 0:
                        w = layoutWidth;
                        h = layoutHeight;
                        break;
                    case 1:
                    case 2:
                        if(ratio<1){
                            w = parseInt(w * ratio);
                            h = parseInt(h * ratio);
                        }
                        break;
                    case 3:
                        w = parseInt(w * ratio);
                        h = parseInt(h * ratio);
                        break;
                }
                imgDom.style.height = h + "px";
                imgDom.style.width = w + "px";
                imgDom.style.marginTop = (layoutHeight - h)/2 + "px";
                imgDom.style.marginLeft= (layoutWidth - w)/2 + "px";
            }
            imgDom.src = src;
        }
    },
    getPositionInDocument:function (elem) {
        var rect = elem.getBoundingClientRect(),
            // IE11  window.scrollX  window.scrollY不行
            scroll = {
                x: window.pageXOffset || document.documentElement.scrollLeft,
                y: window.pageYOffset || document.documentElement.scrollTop
            },
            // round values since some browsers (Firefox) like to provide double values
            result = {
                left: Math.round(rect.left) + scroll.x,
                right: Math.round(rect.right) + scroll.x,
                top: Math.round(rect.top) + scroll.y,
                bottom: Math.round(rect.bottom) + scroll.y,
                width: Math.round(rect.width || (rect.right - rect.left)),
                height: Math.round(rect.height || (rect.bottom - rect.top))
            };

        return result;
    },
    getCoordinates:function(evt, rootElement) {
        evt = evt || window.event;
        var target =evt.target || evt.srcElement,
            point = {
                x:evt.offsetX || evt.layerX,
                y:evt.offsetY || evt.layerY
            };
        var rect = UiTool.getPositionInDocument(rootElement);

        if(target !== rootElement) {
            point.x = Math.max(this.getPositionInDocument(target).left  - rect.left + (evt.offsetX || evt.layerX),0);
            point.y = Math.max(this.getPositionInDocument(target).top - rect.top + (evt.offsetY || evt.layerY),0);
        }
        rect = {
            x:Math.round(point.x),
            y:Math.round(point.y)
        };
        return rect;
    }
    // hasClassName:function (element, className) {
    //     if (!element) return;
    //     var elementClassName = element.className;
    //     if (elementClassName.length == 0) return false;
    //     //用正则表达式判断多个class之间是否存在真正的class（前后空格的处理）
    //     if (elementClassName == className || elementClassName.match(new RegExp("(^|\\s)" + className + "(\\s|$)")))
    //         return true;
    //     return false;
    // },
    // addClassName:function (element, className) {
    //     if (!element) return;
    //     var elementClassName = element.className;
    //     if (elementClassName.length == 0) {
    //         element.className = className;
    //         return;
    //     }
    //     if (elementClassName == className || elementClassName.match(new RegExp("(^|\\s)" + className + "(\\s|$)")))
    //         return;
    //     element.className = elementClassName + " " + className;
    // },
    // removeClassName:function (element, className) {
    //     if (!element) return;
    //     var elementClassName = element.className;
    //     if (elementClassName.length == 0) return;
    //     if (elementClassName == className) {
    //         element.className = "";
    //         return;
    //     }
    //     if (elementClassName.match(new RegExp("(^|\\s)" + className + "(\\s|$)")))
    //         element.className = elementClassName.replace((new RegExp("(^|\\s)" + className + "(\\s|$)")), " ");
    // },
    // getPos:function (pTarget) {
    //     pTarget = this.$E(pTarget);
    //     if (!pTarget.getBoundingClientRect) {
    //         var x_ = y_ = 0;
    //         while (pTarget.offsetParent) {
    //             x_ += pTarget.offsetLeft;
    //             y_ += pTarget.offsetTop;
    //             pTarget = pTarget.offsetParent;
    //         }
    //         x_ += pTarget.offsetLeft;
    //         y_ += pTarget.offsetTop;
    //         return {x:x_, y:y_}
    //     } else {
    //         var body = document.compatMode == 'CSS1Compat' ? document.documentElement : document.body;
    //         var rect = pTarget.getBoundingClientRect()
    //         return {x:rect.left + body.scrollLeft, y:rect.top + body.scrollTop};
    //     }
    // },
    // getMousePoint:function (ev) {
    //     var SupportsTouches = ("createTouch" in document),
    //         x = y = 0,
    //         doc = document.documentElement,
    //         body = document.body;
    //     if (!ev) ev = window.event;
    //     if (window.pageYOffset) {
    //         x = window.pageXOffset;
    //         y = window.pageYOffset;
    //     } else {
    //         x = (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
    //         y = (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    //     }
    //     if (SupportsTouches) {
    //         var evt = ev.touches.item(0);//仅支持单点触摸,第一个触摸点
    //         x = evt.pageX;
    //         y = evt.pageY;
    //     } else {
    //         x += ev.clientX;
    //         y += ev.clientY;
    //     }
    //     return {'x':x, 'y':y};
    // },
    // preventDefault:function (ev) {
    //     if (ev)ev.preventDefault();
    //     else window.event.returnValue = false;
    // },
    // turnEvent:function (type) {
    //     var EventMap = {
    //         mousedown:"touchstart",
    //         mousemove:"touchmove",
    //         mouseup:"touchend",
    //         mouseover:"touchstart",
    //         mouseout:"-",
    //         click:"touchstart"
    //     }
    //     if (UiTool.isSupportsTouches()) {
    //         if (EventMap.hasOwnProperty(type)) {
    //             return EventMap[type];
    //         }
    //     }
    //     return type;
    // },
    // isSupportsTouches:function (type) {
    //     return ("createTouch" in document)
    // },
    // drag:function (o, opt) {
    //     var SupportsTouches = ("createTouch" in document),
    //         StartEvent = UiTool.turnEvent("mousedown"), //支持触摸式使用相应的事件替代
    //         MoveEvent = UiTool.turnEvent("mousemove"),
    //         EndEvent = UiTool.turnEvent("mouseup"),
    //         me = this;
    //     if (typeof o == "string") o = document.getElementById(o);
    //     o.orig_index = o.style.zIndex;
    //     o.startX = 0;
    //     o.startY = 0;
    //     o['on' + StartEvent] = function (e) {
    //         var d = document,
    //             result = {},
    //             x,
    //             y,
    //             limitRect;
    //         this.style.zIndex = 10000;
    //         if (opt.rect) {
    //             limitRect = opt.rect();
    //         }
    //         if (!e)e = window.event;
    //         e.preventDefault();
    //         if (SupportsTouches) {
    //             var evt = e.touches.item(0);
    //             x = evt.pageX;
    //             y = evt.pageY;
    //         } else {
    //             x = e.clientX + d.body.scrollLeft;
    //             y = e.clientY + d.body.scrollTop;
    //         }
    //         //记录原始位置
    //         var start = {x:parseInt(o.offsetLeft), y:parseInt(o.offsetTop)};
    //         d.ondragstart = "return false;";
    //         d.onselectstart = "return false;";
    //         d.onselect = "document.selection.empty();";
    //         if (o.setCapture)
    //             o.setCapture();
    //         else if (window.captureEvents)
    //             window.captureEvents(Event.MOUSEMOVE | Event.MOUSEUP);
    //         opt.onDown && opt.onDown((parseInt(o.style.left) - limitRect.x) / limitRect.w);
    //         Event.addEvent(d, MoveEvent, mouseDragMove);
    //         Event.addEvent(d, EndEvent, mouseDragUp);
    //         function mouseDragMove(e) {
    //             if (!e)e = window.event;
    //             //计算出鼠标移动距离
    //             if (SupportsTouches) {
    //                 var evt = e.touches.item(0);//仅支持单点触摸,第一个触摸点
    //                 result.x = evt.pageX - x;
    //                 result.y = evt.pageY - y;
    //             } else {
    //                 result.x = e.pageX ? e.pageX - x : e.clientX + document.body.scrollLeft - x;
    //                 result.y = e.pageY ? e.pageY - y : e.clientY + document.body.scrollTop - y;
    //             }
    //             result.x = start.x + result.x;
    //             result.y = start.x + result.y;
    //
    //             if (limitRect) {
    //                 if (result.x < limitRect.x) {
    //                     result.x = limitRect.x
    //                 } else if (result.x > (limitRect.x + limitRect.w)) {
    //                     result.x = limitRect.x + limitRect.w;
    //                 }
    //                 if (result.y < limitRect.y) {
    //                     result.y = limitRect.y;
    //                 } else if (result.y > (limitRect.y + 0 + limitRect.h)) {
    //                     result.y = limitRect.y + limitRect.h;
    //                 }
    //             }
    //             o.style.left = result.x + "px";
    //             o.style.top = result.y + "px";
    //
    //             opt.onMove && opt.onMove((parseInt(o.style.left) - limitRect.x) / limitRect.w);
    //             return false;
    //         }
    //
    //         function mouseDragUp() {
    //             if (o.releaseCapture)
    //                 o.releaseCapture();
    //             else if (window.captureEvents)
    //                 window.captureEvents(Event.MOUSEMOVE | Event.MOUSEUP);
    //             Event.removeEvent(d, MoveEvent, mouseDragMove);
    //             Event.removeEvent(d, EndEvent, mouseDragUp);
    //             o.style.zIndex = o.orig_index;
    //             opt.onUp && opt.onUp((parseInt(o.style.left) - limitRect.x) / limitRect.w);
    //         }
    //
    //         return false;
    //     }
    // },
    // fullScreen:function (element) {
    //     if (element.requestFullscreen) {
    //         return  element.requestFullscreen();
    //     } else if (element.mozRequestFullScreen) {
    //         return  element.mozRequestFullScreen();
    //     } else if (element.webkitRequestFullscreen) {
    //         return element.webkitRequestFullScreen();
    //     } else if (element.msRequestFullscreen) {
    //         return  element.msRequestFullscreen();
    //     } else if (element.oRequestFullscreen) {
    //       return  element.oRequestFullscreen();
    //     }
    //
    // },
    // isFullScreen:function () {
    //     if((document.webkitIsFullScreen || document.fullscreen || document.mozFullScreen || document.msFullscreenElement)){
    //         return true;
    //     }
    //     return false;
    // },
    // cancelFullScreen:function () {
    //     if (document.cancelFullscreen) {
    //         document.cancelFullscreen();
    //     } else if (document.exitFullscreen) {
    //         document.exitFullscreen();
    //     } else if (document.msExitFullscreen) {
    //         document.msExitFullscreen();
    //     } else if (document.mozCancelFullScreen) {
    //         document.mozCancelFullScreen();
    //     } else if (document.webkitExitFullscreen) {
    //         document.webkitExitFullscreen();
    //     } else if (document.webkitCancelFullScreen) {
    //         element.webkitCancelFullScreen();
    //     }
    // },
    // supportFullScreen:function () {
    //     var doc = document.documentElement;
    //     return ('requestFullscreen' in doc) ||
    //         ('mozRequestFullScreen' in doc && document.mozFullScreenEnabled) ||
    //         ('webkitRequestFullscreen' in doc) || ('msRequestFullscreen' in doc);
    // },
    // getClientWidth:function () {
    //     return document.body.clientWidth;
    // },
    // getImgRealRect:function (img) {
    //     var imgWidth = img.width;
    //     var imgHeight = img.height;
    //     if (typeof img.naturalWidth != "undefined") {
    //         imgWidth = img.naturalWidth;
    //         imgHeight = img.naturalHeight;
    //     }
    //     return {width:imgWidth,height:imgHeight};
    // },
    // isMobileEvent:function(type){
    //     return ["touchstart","touchmove","touchend"].indexOf(type)!=-1;
    // }
};
export default UiTool;